<template>
  <div class="layout-runtime">
    <div
      class="draggable-module"
      v-for="(initComponent,index) in component.children"
      :style="getRatioStyle(index)"
      :key="initComponent.id">
      <component
        ref="children"
        v-if="!initComponent.properties.hidden"
        :is="initComponent.componentType"
        :component="initComponent"
        :value="getChildrenData(component)"
        :parentPath="getCurrentPath()"
        :disabled="disabled"
        :dialogWidth="dialogWidth"
        @initDefaultValue="initDefaultValue"
        @initRelated="initRelated"
        @input="(buildData) => updateChildValue(component.archive.columnId, buildData)"
        @calculation="(expression) => calculation(expression)">
      </component>
    </div>
  </div>
</template>

<script>
import {containerInitMixin, componentMixin, containerMixin, calculationMixin, relFunMixin, defaultValueMixin} from './mixins'
import {ruleGenerator} from './rule'
import RcDraggable from './rc-draggable.vue'

export default {
  name: 'rc-layout',
  mixins: [componentMixin, containerMixin, calculationMixin, relFunMixin, ruleGenerator, defaultValueMixin, containerInitMixin],
  props: ['component', 'value', 'disabled', 'parentComponent', 'dialogWidth'],
  data () {
    return {}
  },
  components: {
    RcDraggable
  },
  methods: {
    initRelated (component, callback) {
      this.$emit('initRelated', component, callback)
    },
    initDefaultValue (component, callback) {
      this.$emit('initDefaultValue', component, callback)
    },
    getRatioStyle (index) {
      let width = 1 / this.component.children.length * 100 + '%'
      if (this.component.properties.layoutRatioType) {
        let countRatio = 0
        let ratioArray = this.component.properties.layoutRatioType.split(':')
        ratioArray.forEach(e => { countRatio += Number(e) })
        width = ratioArray[index] / countRatio * 100 + '%'
      }
      let style = {'width': width}
      return style
    }
  }
}
</script>

<style lang="scss">
  .layout-runtime {
    .draggable-module {
      display: inline-block;
      vertical-align: top;
      padding: 0 5px;
      &:first-child {
        padding-left: 0 !important;
      }
      &:last-child {
        padding-right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-layout.vue